import { render, staticRenderFns } from "./withdraw_reject_reasons.vue?vue&type=template&id=41b3aeda&scoped=true&"
import script from "./withdraw_reject_reasons.vue?vue&type=script&lang=js&"
export * from "./withdraw_reject_reasons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b3aeda",
  null
  
)

export default component.exports